import * as React from "react";
import { useCallback, useContext } from "react";
import { JobInfoContext } from "../../../job-info-context";
import { JobApi } from "../../../api";
import { InputSwitch } from "primereact/inputswitch";
import { Badge } from "primereact/badge";
import * as Messages from "../../../Messages";
import { useVinaJobDesiredRunContext } from "../context/vina-job-desired-run-context";

export function VinaJobDesiredRunSwitch() {

  const {id} = useContext(JobInfoContext);

  const {
    fetching,
    withFetchState,

    allowed,
    triggered,

    scheduled,
    inQueue,
    inProgress,
    failed,
    done,

    desiredRun,
    fetchAndSetDesiredRun
  } = useVinaJobDesiredRunContext();

  const onChange = useCallback(({value}: { value: boolean }) => {
    if (value) {
      const c = window.confirm(Messages.VIRTUAL_SCREENING_SWITCH_ALERT());
      if (!c) {
        return;
      }
    }
    withFetchState(() => JobApi.vinaSetDesiredRun({id, value}))
      .then(() => {
        fetchAndSetDesiredRun();
      })
      .catch(err => console.error(err));
  }, [id, fetchAndSetDesiredRun, withFetchState]);

  return (
    <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
      <InputSwitch
        checked={(desiredRun === true || triggered) && allowed === true}
        disabled={desiredRun === null || fetching || triggered || allowed === false}
        onChange={onChange}
        style={{transform: 'scale(0.8)', marginLeft: '-5px', marginRight: '-5px'}}
      />
      {allowed === false && (
        <Badge value="NOT AVAILABLE" severity="warning"/>
      )}
      {scheduled && (
        <Badge value="SCHEDULED"/>
      )}
      {inQueue && (
        <Badge value="IN QUEUE"/>
      )}
      {inProgress && (
        <Badge value="IN PROGRESS"/>
      )}
      {failed && (
        <Badge value="FAILED" severity="danger"/>
      )}
      {done && (
        <Badge value="DONE" severity="success"/>
      )}
      {fetching && Messages.spinnerIcon}
    </div>
  )
}